import React, { FC } from 'react';
import classNames from 'classnames';
import nextId from 'react-id-generator';
import {
    OnSelectFamilyCrestColor,
    ProductThumbnailYesorNo,
    ProductThumbnailColor,
} from '@app/react/uikit';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    GetResponseFamilyCrestColors,
    PartsProduct,
    FamilyCrestColor,
} from '@app/react/const/type';

const CP = 'kamon-select-button';

const getImgPathWithDefault = (
    familycrest: PartsProduct | null,
): string => familycrest?.productImages?.[0] || `${ASSETS_PATH}/svg/kamon-ari.svg`;

const getName = (product: PartsProduct) => {
    const p = product?.price?.toLocaleString();
    if (p === undefined) {
        return '---';
    }
    return p;
};

interface IKamonBodyDesktopComponentProps {
    noProduct: PartsProduct;
    yesProduct: PartsProduct;
    familycrestColorsData: GetResponseFamilyCrestColors | null;
    familycrestOk: boolean;
    familycrest: PartsProduct | null;
    familycrestColor: FamilyCrestColor | null;
    onClickNoProduct: () => void;
    onClickYesProduct: () => void;
    onSelectFamilyCrestColor: OnSelectFamilyCrestColor;
    showPanel: () => void;
}

export const KamonBodyDesktopComponent: FC<IKamonBodyDesktopComponentProps> = (
    props,
) => {
    const {
        noProduct,
        yesProduct,
        familycrestColorsData,
        familycrestOk,
        familycrest,
        familycrestColor,
        onSelectFamilyCrestColor,
        onClickNoProduct,
        onClickYesProduct,
        showPanel,
    } = props;

    const htmlId = nextId('familycrest-color');
    const ksd = { 'kamon-select-disable': !familycrestOk };

    return (
        <div className="order-kamon">
            <div className="order-kamon__body">
                <div className="order-kamon-select-div">
                    <p className="tab-string-label-title">①家紋の有無</p>
                    <div className="tab-string-content">
                        <ProductThumbnailYesorNo
                            name={`${noProduct.name}（+¥${noProduct.price.toLocaleString()}/本）`}
                            clicked={!familycrestOk}
                            imgSrc={noProduct.productImages[0]}
                            onChange={onClickNoProduct}
                            groupName="kamondesk"
                        />
                        <ProductThumbnailYesorNo
                            name={`${yesProduct.name}（+¥${getName(yesProduct)}/本）`}
                            clicked={familycrestOk}
                            imgSrc={yesProduct.productImages[0]}
                            onChange={onClickYesProduct}
                            groupName="kamondesk"
                        />
                    </div>

                    <p className={classNames('tab-string-label-title', ksd)}>
                        ②家紋の選択
                    </p>
                    <div className={classNames('tab-string-content', ksd)}>
                        <label
                            htmlFor="TAB-COLOR-07"
                            className="tab-string-label"
                        >
                            <div className={CP}>
                                <div className={`${CP}__image-wapper`}>
                                    <img
                                        className={`${CP}__image`}
                                        src={getImgPathWithDefault(familycrest)}
                                        alt={
                                        familycrest?.name
                                        || '家紋未選択状態'
                                        }
                                    />
                                </div>
                                <div className={`${CP}__text`}>
                                    家紋名：
                                    {familycrest?.name || '未選択'}
                                </div>
                                <button
                                    type="button"
                                    className={`${CP}__preview-button`}
                                    onClick={showPanel}
                                >
                                    選択画面へ
                                </button>
                                <div className={`${CP}__icon-selected`} />
                            </div>
                        </label>
                    </div>

                    <p className={classNames('tab-string-label-title', ksd)}>
                        ③インクの色選択
                    </p>
                    <div className={classNames('tab-string-content', ksd)}>
                        <ul className="order-kamon-select-div__product-container">
                            {familycrestColorsData?.colorData.filter((pl) => pl.enable).map((product) => (
                                <ProductThumbnailColor
                                    key={product.id}
                                    product={product}
                                    onClick={onSelectFamilyCrestColor}
                                    checked={
                                    familycrestColor?.id === product.id
                                    }
                                    groupName={htmlId}
                                />
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};
